import React, { useState } from 'react';
import { Button, Toast } from 'react-bootstrap';
import { AiFillCheckCircle, AiFillCloseCircle } from 'react-icons/ai';
import { BsFillExclamationCircleFill } from 'react-icons/bs';


const ToasterMessage = (props) => {

    const { toaster, setToaster, response } = props;
    const [showA, setShowA] = useState(true);
    const [showB, setShowB] = useState(true);

    const toggleShowA = () => setShowA(!showA);
    const toggleShowB = () => setShowB(!showB);

    return (
        <React.Fragment>
            <div className='toaster-message'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Task Assigned Successfully" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--green'>
                                    <div className='d-flex'>
                                        <AiFillCheckCircle style={{ fontSize: "30px", color: "#2BDE3F" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Task Assigned Successfully</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Task Successfully Completed" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--green'>
                                    <div className='d-flex'>
                                        <AiFillCheckCircle style={{ fontSize: "30px", color: "#2BDE3F" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Task Successfully Completed</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Success" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--green'>
                                    <div className='d-flex'>
                                        <AiFillCheckCircle style={{ fontSize: "30px", color: "#2BDE3F" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Success</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowB} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Error" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--red '>
                                    <div className='d-flex'>
                                        <AiFillCloseCircle style={{ fontSize: "30px", color: "#D8000C" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Something Went Wrong</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowB} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Error1" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--red '>
                                    <div className='d-flex'>
                                        <AiFillCloseCircle style={{ fontSize: "30px", color: "#D8000C" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>You need at least Rs. 10,000 to initiate the payment request</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowB} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Pending Task" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--red '>
                                    <div className='d-flex'>
                                        <AiFillCloseCircle style={{ fontSize: "30px", color: "#D8000C" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>You have pending Tasks, You cannot delete account now</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowB} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Mismatch" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--warning '>
                                    <div className='d-flex'>
                                        <BsFillExclamationCircleFill style={{ fontSize: "30px", color: "#F9A02C" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Password Mismatch</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Sucessfully Added" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--green'>
                                    <div className='d-flex'>
                                        <AiFillCheckCircle style={{ fontSize: "30px", color: "#2BDE3F" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Sucessfully Added</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Sucessfully Deleted" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--green'>
                                    <div className='d-flex'>
                                        <AiFillCheckCircle style={{ fontSize: "30px", color: "#2BDE3F" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Successfully Deleted</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Enter Amount" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--warning '>
                                    <div className='d-flex'>
                                        <BsFillExclamationCircleFill style={{ fontSize: "30px", color: "#F9A02C" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Please Enter Amount</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Save Changes" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--green'>
                                    <div className='d-flex'>
                                        <AiFillCheckCircle style={{ fontSize: "30px", color: "#2BDE3F" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Save Changes Successfully</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Post Task" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--green'>
                                    <div className='d-flex'>
                                        <AiFillCheckCircle style={{ fontSize: "30px", color: "#2BDE3F" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Successfully Posted Task</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Invalid credentials" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--red'>
                                    <div className='d-flex'>
                                        <AiFillCloseCircle style={{ fontSize: "30px", color: "#D8000C" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Invalid credentials</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Invalid mobile" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--red'>
                                    <div className='d-flex'>
                                        <AiFillCloseCircle style={{ fontSize: "30px", color: "#D8000C" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Invalid Mobile Number</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>

                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Invalid time Slot" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--red'>
                                    <div className='d-flex'>
                                        <AiFillCloseCircle style={{ fontSize: "30px", color: "#D8000C" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Invalid time Slot</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>

                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Low Balance" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--red'>
                                    <div className='d-flex'>
                                        <AiFillCloseCircle style={{ fontSize: "30px", color: "#D8000C" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Low Balance</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Server Side issue" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--red'>
                                    <div className='d-flex'>
                                        <AiFillCloseCircle style={{ fontSize: "30px", color: "#D8000C" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Server Side issue</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Task Success" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--green'>
                                    <div className='d-flex'>
                                        <AiFillCheckCircle style={{ fontSize: "30px", color: "#2BDE3F" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Task Successfully Completed</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Log Out" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--green'>
                                    <div className='d-flex'>
                                        <AiFillCheckCircle style={{ fontSize: "30px", color: "#2BDE3F" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Log Out Successfully</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "Add Bank Account" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--red'>
                                    <div className='d-flex'>
                                        <AiFillCloseCircle style={{ fontSize: "30px", color: "#D8000C" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Add Bank Account details</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                        <div className='col-lg-12'>
                            {/* <Button onClick={toggleShowA} className="mb-2">
                                Success <strong>with</strong> Animation
                            </Button> */}
                            <Toast show={toaster == "User offline" ? true : false} onClose={() => setToaster(false)} className="toaster-setting border-0">

                                <Toast.Body className='toast-msg toast--red'>
                                    <div className='d-flex'>
                                        <AiFillCloseCircle style={{ fontSize: "30px", color: "#D8000C" }} />
                                        <div className='ms-2' style={{ fontSize: "18px", fontWeight: "500" }}>Low Balance</div>
                                    </div>
                                    <Toast.Header className='btn-close-toaster justify-content-end' style={{ borderBottom: "none", boxShadow: "none" }}>
                                    </Toast.Header>
                                </Toast.Body>
                            </Toast>

                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default ToasterMessage;